<!--
Author: TangChen
Date: 2018-10-08
Desc: 手机号码绑定，由index.js 配置引入
 -->
<template>
    <div v-if="showMobileComp">
        <div v-if="!showChangeMobile" class="bizcomp-check-mobile">
            <my-dialog
                class="my-dialog-contain"
                :title="dialogTitle"
                :visible="visible"
                width="620px"
                :dialog-close="checkDialogClose"
            >
                <div v-if="!bankCardVisible" class="acct-con">
                    <div class="check-acct">
                        <el-form
                            ref="pwdForm"
                            :model="pwdForm"
                            :rules="rules"
                            inline-message
                            v-on:submit.native.prevent
                        >
                            <el-form-item label="原手机号码:" class="form-text">
                                <el-select
                                    v-model="mobileNoCode"
                                    class="select-mobile-Code"
                                    placeholder="请选择手机号码国家码"
                                    :disabled="true"
                                ></el-select>
                                <el-input
                                    v-model.trim="info.mobileno"
                                    class="input-mobile"
                                    placeholder="请输入手机号码"
                                    :maxlength="11"
                                    :disabled="true"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="手机验证码:"
                                prop="verifyCode"
                                class="verifycode-row"
                            >
                                <el-input
                                    v-model.trim="pwdForm.verifyCode"
                                    class="verifycode-style"
                                    placeholder="请输入验证码"
                                    :maxlength="6"
                                ></el-input>
                                <span class="get-verify" :disabled="time > 0" v-on:click="sendCode">
                                    {{ btnMsg }}
                                </span>
                            </el-form-item>
                            <el-form-item class="tips-row">
                                <span class="tips-text">如果手机号码不再使用，请点击</span>
                                <span class="tips-to-text" v-on:click="verifyBankCard">这里</span>
                            </el-form-item>
                            <el-form-item>
                                <div class="btn-contain">
                                    <button class="cancel-btn" v-on:click="checkDialogClose">
                                        取消
                                    </button>
                                    <button class="confirm-btn" v-on:click="submitForm('pwdForm')">
                                        确定
                                    </button>
                                </div>
                            </el-form-item>
                            <el-form-item class="warn-tip">
                                <div>
                                    <div class="tip-title">温馨提示</div>
                                    <div class="tip-text margin-10">
                                        1、为了确保你的账户安全，
                                        <span class="color-e60012">
                                            修改手机号码需通过原手机号码获取并输入手机验证码
                                        </span>
                                        ，验证通过后方能更换成功；
                                    </div>
                                    <div class="tip-text">
                                        2、若你的手机多次获取验证码均无法收到，请检验手机是否设置了短信拦截。
                                    </div>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <check-bank-card
                    v-else
                    v-on:check-dialog-close="checkDialogClose"
                    v-on:check-card-apply="checkCardApply"
                    v-on:change-title="changeTitle"
                ></check-bank-card>
            </my-dialog>
            <img-code
                :dialog-visible="dialogVisible"
                :biztype="$const.IMG_BIZTYPE.CHANGEMOBILE"
                v-on:verify-in="getVerifyCode"
            />
        </div>
        <div v-else>
            <change-mobile
                :modifytype="modifytype"
                :dialog-title="dialogTitle"
                v-on:change-dialog-close="checkDialogClose"
            ></change-mobile>
        </div>
        <mobile-code
            :mobile-visible="mobileVisible"
            :mobile-no="cardMobileNo"
            v-on:verify-in="checkMobileCode"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import imgCode from "@/components/layout/imgCode.vue";
import userApi from "@/api/user";
import myDialog from "@/components/layout/myDialog.vue";
import ChangeMobile from "./changeMobileDc.vue";
import checkBankCard from "./checkBankCard.vue";
import mobileCode from "@/components/layout/mobileCodeDc.vue";

export default {
    name: "CheckAcct",
    components: {
        imgCode,
        myDialog,
        ChangeMobile,
        checkBankCard,
        mobileCode
    },
    mixins: [mixin],
    props: {
        showMobileComp: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mobileNoCode: "中国 + 86",
            visible: true,
            showChangeMobile: false,
            time: 0, // 验证码再次发送间隔
            pwdForm: {
                // 表单参数配置
                mobileno: "",
                verifyCode: ""
            },
            info: {},
            dialogVisible: false,
            bankCardVisible: false,
            btnMsg: "获取验证码",
            locked: false, // 是否已发送短信验证码
            rules: {
                // 校验规则
                verifyCode: [
                    {
                        validator: this.$util.validateVerifyCode,
                        trigger: "blur"
                    }
                ]
            },
            bankCardInfo: null, // 银行卡鉴权信息
            cardMobileNo: "", // 银行卡绑定手机号
            mobileVisible: false, // 是否显示验证手机号弹窗
            modifytype: "1", // 修改手机号验证类型：1-短信、2-银行卡鉴权；不传默认短信
            randomToken: ""
        };
    },
    computed: {
        dialogTitle() {
            return `${this.info.mobileno ? "修改" : "增加"}手机号码`;
        }
    },
    watch: {
        showMobileComp(value) {
            this.info = this.$cache.getUser();
            if (value && !this.info.mobileno) {
                this.showChangeMobile = true;
            } else {
                this.showChangeMobile = false;
                this.visible = value;
            }
        }
    },
    created() {
        this.time = 0;
        this.info = this.$cache.getUser();
    },
    methods: {
        changeTitle() {
            this.title = "温馨提示";
        },
        checkDialogClose() {
            this.visible = false;
            this.showChangeMobile = false;
            this.bankCardVisible = false;
            this.pwdForm.verifyCode = "";
            this.pwdForm.mobileno = "";
            if (this.locked) {
                this.time = 0;
                this.btnMsg = "获取验证码";
                this.$util.btnDisabled(this);
                this.locked = false;
            }
            this.$emit("dialog-close", false);
        },
        // 使用银行卡验证
        verifyBankCard() {
            this.bankCardVisible = true;
        },
        // 银行卡验证弹窗回调
        checkCardApply(val) {
            this.bankCardInfo = val;
            if (this.$cache.getSysParam("10103010") == "2") {
                this.checkBankCard();
            } else {
                this.dialogVisible = true;
            }
        },
        // 银行卡验证鉴权申请
        async checkBankCard() {
            if (this.bankCardInfo.verifytype == "0") {
                // 页面鉴权或签约
                this.randomToken = this.$util.generateRandomNumber();
                let pagecallbackurl =
                    window.location.origin +
                    "" +
                    "/sale-mid-ump/bank/redirect?token=" +
                    this.randomToken;
                // 建行网联的回调地址配置在银行那边，需要单独处理
                if (this.bankCardInfo.paycenterid == "0105") {
                    pagecallbackurl = window.location.origin + "" + "/sale-mid-ump/bank/ccb";
                }
                this.bankCardInfo.pagecallbackurl = pagecallbackurl;
            }
            const res = await userApi.modifyMobileAuthApply(
                this.bankCardInfo,
                this.$cache.getIsEncrypted()
            );
            if (res.code == "0") {
                if (this.dialogVisible) {
                    this.dialogVisible = false;
                }
                if (this.bankCardInfo.verifytype == "1") {
                    // 短信鉴权或签约
                    setTimeout(() => {
                        this.cardMobileNo = this.bankCardInfo.mobileno;
                        this.mobileVisible = true;
                    }, 500);
                } else {
                    // 页面鉴权或签约
                    const pageUrl = res.data.bankgateurl ? res.data.bankgateurl : "";
                    let pageParam = res.data.bankgateparam ? res.data.bankgateparam : {};
                    if (pageParam) {
                        pageParam = JSON.parse(pageParam);
                    }
                    const bankgateserialno = res.data.bankgateserialno;
                    const reqMethod = res.data.method;
                    this.$util.openPostWindow(pageUrl, pageParam, reqMethod, "_blank");
                    const params = {
                        token: this.randomToken,
                        certificatetype: this.bankCardInfo.certificatetype,
                        bankcode: this.bankCardInfo.bankcode,
                        bankcardid: this.bankCardInfo.bankcardid,
                        mobileno: this.bankCardInfo.mobileno,
                        paychannel: this.bankCardInfo.paycenterid,
                        bankgateserialno: bankgateserialno,
                        signtype: "0",
                        changeMobileByBank: true,
                        isAuthFlag: this.bankCardInfo.authbiztype == "01"
                    };
                    if (this.$cache.getIsEncrypted()) {
                        params.en_depositname = this.bankCardInfo.en_depositname;
                        params.en_certificateno = this.bankCardInfo.en_certificateno;
                        params.en_depositcard = this.bankCardInfo.en_depositcard;
                    } else {
                        params.depositname = this.bankCardInfo.depositname;
                        params.certificateno = this.bankCardInfo.certificateno;
                        params.depositcard = this.bankCardInfo.depositcard;
                    }
                    this.$util.confirmBankAuth(this, params, "BankPageAuthentication", () => {
                        this.modifytype = "2";
                        this.visible = false;
                        this.bankCardVisible = false;
                        this.mobileVisible = false;
                        this.showChangeMobile = true;
                    });
                }
            }
        },
        // 银行卡鉴权验认证
        async checkMobileCode(code) {
            if (code) {
                const res = await userApi.modifyMobileAuthConfirm({
                    smscode: code
                });
                if (res.code == "0") {
                    this.modifytype = "2";
                    this.visible = false;
                    this.bankCardVisible = false;
                    this.mobileVisible = false;
                    this.showChangeMobile = true;
                }
            } else {
                this.mobileVisible = false;
            }
        },
        /* 提交表单数据,校验手机验证码 */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.locked) {
                        this.$message({
                            type: "warning",
                            message: "请先发送手机短信验证码"
                        });
                        return false;
                    }
                    this.checkVerifyCode();
                } else {
                    this.$errorScroll();
                }
            });
        },
        // 获取验证码
        sendCode() {
            if (this.time > 0) return;
            if (this.bankCardInfo) {
                // 如果存在银行卡鉴信息则置空
                this.bankCardInfo = null;
            }
            if (this.$cache.getSysParam("10103010") == "2") {
                this.getVerifyCode("1");
            } else {
                this.dialogVisible = true;
            }
        },
        /* 校验手机验证码 */
        async checkVerifyCode() {
            const res = await userApi.checkSmsCode({
                smscode: this.pwdForm.verifyCode,
                biztype: this.$const.IMG_BIZTYPE.CHANGEMOBILE
            });
            if (res.code === "0") {
                this.showChangeMobile = true;
                this.time = 0;
                this.btnMsg = "获取验证码";
                this.$util.btnDisabled(this);
            }
        },
        /* 获取图形验证码值 */
        async getVerifyCode(val) {
            const _this = this;
            if (!val) {
                this.dialogVisible = false;
                return;
            }
            if (val || this.$cache.getSysParam("10103010") == "2") {
                if (this.bankCardInfo) {
                    // 银行卡鉴权
                    this.bankCardInfo.verifycode = val;
                    this.checkBankCard();
                    return;
                }
                let isDecryptObj = {};
                if (this.$cache.getIsEncrypted()) {
                    isDecryptObj.en_mobileno = this.$cache.getUser().en_mobileno;
                } else {
                    isDecryptObj.mobileno = this.$cache.getUser().mobileno;
                }
                const res = await userApi.sendSms(
                    {
                        ...isDecryptObj,
                        biztype: this.$const.IMG_BIZTYPE.CHANGEMOBILE,
                        verifycode: val
                    },
                    this.$cache.getIsEncrypted()
                );
                if (res.data) {
                    this.dialogVisible = false;
                    _this.time = res.data.sendperiod;
                    _this.locked = true;
                    _this.$util.btnDisabled(_this);
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-check-mobile {
    .acct-con {
        padding: 40px 40px 20px;
        :deep(.el-form-item) {
            margin: 0;
        }
        :deep(.el-form-item__error--inline) {
            margin-left: 90px;
        }
        .form-text {
            margin-bottom: 23px;
            .select-mobile-Code {
                width: 130px;
            }
            .input-mobile {
                width: 276px;
                margin-left: 10px;
            }
        }
        .verifycode-row {
            font-size: 14px;
            font-weight: normal;
            color: var(--color-text-primary);
            .verifycode-style {
                position: relative;
                width: 416px;
                border-radius: 2px;
                background: #ffffff;
                box-sizing: border-box;
                border: 1px solid var(--color-border-base);
            }
            .get-verify {
                position: absolute;
                right: 50px;
                font-size: 16px;
                font-weight: normal;
                cursor: pointer;
                color: var(--color-primary);
            }
        }
        .tips-row {
            padding-left: 90px;
            .tips-text {
                height: 20px;
                font-size: 14px;
                font-weight: normal;
                line-height: 20px;
                color: var(--color-text-accent);
            }
            .tips-to-text {
                margin-left: 6px;
                height: 20px;
                font-size: 14px;
                font-weight: normal;
                color: var(--color-primary);
                cursor: pointer;
            }
        }
        .btn-contain {
            margin-top: 20px;
            text-align: center;
            .cancel-btn {
                padding: 10px 0;
                width: 180px;
                border-radius: 2px;
                background: var(--color-border-base);
                font-size: 16px;
                font-weight: 500;
                color: var(--color-text-regular);
                border: 1px solid var(--color-border-base);
                cursor: pointer;
            }
            .confirm-btn {
                margin-left: 40px;
                padding: 10px 0;
                width: 180px;
                border-radius: 2px;
                background: var(--color-primary);
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
                border: 1px solid var(--color-primary);
                cursor: pointer;
            }
        }
        .warn-tip {
            padding: 25px 30px 30px 0;
            .tip-title {
                font-size: 16px;
                font-weight: normal;
                color: var(--color-text-regular);
                line-height: normal;
            }
            .tip-text {
                font-size: 14px;
                font-weight: normal;
                color: var(--color-text-regular);
                line-height: normal;
            }
        }
    }
    .margin-10 {
        margin: 10px 0;
    }
    .color-e60012 {
        color: var(--color-primary);
    }
}
</style>
